import { getStepBySlug } from '@/helpers/steps'
import { PrivacyBottom } from '@/components/quiz/PrivacyBottom'
import { Title } from '@/components/quiz/Title'
import { RadioGrid } from '@/components/quiz/RadioGrid'
import { NextStep } from '@/components/quiz/NextStep'
import { Image } from '@/components/quiz/Image'
import { UserCountBanner } from '@/components/quiz/UserCountBanner'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Header } from '@/components/quiz/Header'
import { ProgressBar } from '@/components/quiz/ProgressBar'
import { Description } from '@/components/quiz/Description'
import { CheckboxButtons } from '@/components/quiz/CheckboxButtons'
import { RadioButtons } from '@/components/quiz/RadioButtons'
import { TimelineSlider } from '@/components/quiz/TimelineSlider'
import { NumberCounter } from '@/components/quiz/NumberCounter'
import { GraphProfile } from '@/components/quiz/GraphProfile'
import { List } from '@/components/quiz/List'
import { Email } from '@/components/quiz/Email'
import { ProgressLoader } from '@/components/quiz/ProgressLoader'
import { Reviews } from '@/components/quiz/Reviews'
import { useQuizStore } from '@/store/useQuizStore'
import { CardsSwiper } from './quiz/CardsSwiper'
import { Notifications } from './quiz/Notifications'
import { Performance } from './quiz/Performance'
import { Paywall } from '@/components/quiz/paywall/Paywall'
import { Checkout } from '@/components/quiz/paywall/Checkout'
import ThankYou from '@/components/quiz/paywall/ThankYou'
import { VariationStep } from '@/components/quiz/VariationStep'
import { TwoButtons } from '@/components/quiz/TwoButtons'
import { CheckoutPaywall } from '@/components/quiz/paywall/CheckoutPaywall'
import { AmplitudeVariationStep } from '@/components/quiz/AmplitudeVariationStep'
import { SwipeElement } from './quiz/SwipeElement'
import { CustomProgress } from './quiz/CustomProgress'
import { Lottie } from './quiz/Lottie'

export const componentMap: Record<string, React.ComponentType<any>> = {
  title: Title,
  radioGrid: RadioGrid,
  privacyBottom: PrivacyBottom,
  image: Image,
  userCountBanner: UserCountBanner,
  description: Description,
  checkboxButtons: CheckboxButtons,
  radioButtons: RadioButtons,
  timelineSlider: TimelineSlider,
  numberCounter: NumberCounter,
  graphProfile: GraphProfile,
  list: List,
  email: Email,
  progressLoader: ProgressLoader,
  reviews: Reviews,
  cardsSwiper: CardsSwiper,
  notifications: Notifications,
  performance: Performance,
  paywall: Paywall,
  checkout: Checkout,
  thankYou: ThankYou,
  variation: VariationStep,
  variationAmplitude: AmplitudeVariationStep,
  checkoutPaywall: CheckoutPaywall,
  swipeElement: SwipeElement,
  lottie: Lottie,
}

export const QuizStep = ({ quiz, url, version }: { quiz: any; url: string; version?: string }) => {
  const { step } = useParams()
  const navigate = useNavigate()
  const stepData = getStepBySlug(quiz, step ?? '')
  const isAlternative = version === 'alternative'
  const setSlug = useQuizStore((s) => s.setCurrentSlug)
  const [isValid, setIsValid] = useState(!stepData?.step?.navigation?.nextButton?.disabled)

  const handleValidStep = (val: boolean) => {
    setIsValid(val)
  }
  const handleStep = (slug: string) => {
    setSlug(slug)
    navigate(`${url}${slug}`)
  }

  const handlePrevStep = () => {
    handleStep(stepData?.prev?.slug)
  }
  const handleNextStep = () => {
    if (stepData?.index !== stepData?.count) {
      handleStep(stepData?.next?.slug)
    } else {
      navigate('/paywall')
    }
  }

  console.log(isAlternative)
  return (
    <>
      <Header
        hidePrevButton={stepData?.step?.navigation?.prevButton?.hide}
        onPrevStep={handlePrevStep}
        title={stepData?.step?.screenTitle}
      />

      {stepData?.step?.navigation?.progress &&
        (version === 'alternative' ? (
          <ProgressBar currentStep={stepData?.index + 1} lastStep={stepData?.count} />
        ) : (
          <ProgressBar currentStep={stepData?.index - 2} lastStep={stepData?.count - 4} />
        ))}
      {stepData?.step?.navigation?.customProgress && (
        <CustomProgress currentStep={stepData?.step?.navigation?.customProgress} />
      )}

      {stepData?.step?.components?.map((data: any, index: number) => {
        const Component = componentMap[data.component]
        if (!Component) return null
        return (
          <Component
            key={step + data.component + '-' + index}
            data={{ version, ...data }}
            onValid={handleValidStep}
            onNextStep={handleNextStep}
          />
        )
      })}

      {!stepData?.step?.navigation?.nextButton?.hide && (
        <NextStep
          disabled={stepData?.step?.navigation?.nextButton?.disabled && !isValid}
          isStatic={stepData?.step?.navigation?.nextButton?.static}
          text={
            !stepData?.step?.navigation?.nextButton?.disabled || isValid
              ? stepData?.step?.navigation?.nextButton?.text
              : stepData?.step?.navigation?.nextButton?.disabledText
          }
          onNextStep={handleNextStep}
        />
      )}

      {stepData?.step?.navigation?.twoButtons && !stepData?.step?.navigation?.twoButtons?.hide && (
        <TwoButtons onNextStep={handleNextStep} />
      )}
    </>
  )
}
